import { createState } from '../../graph/-state';
export default class ManyRelationship {
  constructor(definition, identifier) {
    this.definition = definition;
    this.identifier = identifier;
    this._state = null;
    this.transactionRef = 0;
    this.localMembers = new Set();
    this.remoteMembers = new Set();
    this.meta = null;
    this.links = null;

    // persisted state
    this.remoteState = [];
    // local client state
    this.localState = [];
  }
  get state() {
    let {
      _state
    } = this;
    if (!_state) {
      _state = this._state = createState();
    }
    return _state;
  }
  getData() {
    let payload = {};
    if (this.state.hasReceivedData) {
      payload.data = this.localState.slice();
    }
    if (this.links) {
      payload.links = this.links;
    }
    if (this.meta) {
      payload.meta = this.meta;
    }
    return payload;
  }
}